import { render } from "./FooterLinkSection.vue?vue&type=template&id=4073b189"
import script from "./FooterLinkSection.vue?vue&type=script&lang=js"
export * from "./FooterLinkSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DELL\\download\\advertisingServiceWebApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__